

import { IRequestDetailEditService } from '../../requestDetailEdit/services/requestDetailEditService';
import { RequestDetailEdit } from '../../requestDetailEdit/models/requestDetailEdit';
import { RequestAssignedMaterialToPackage } from '../../requestDetailEdit/models/requestAssignedMaterialToPackage';
import { SaveResult } from '../../../../core/saveResult';
import { RequestShipment } from '../../requestDetailEdit/models/requestShipment';
import { RequestMaterials } from '../../requestDetailEdit/models/requestMaterials';

export interface IAddRequestService {
    getDetail(copyTrackingId: number): Promise<RequestDetailEdit>;
    
    submitRequestWithAttachments(requestDetailEditModel: RequestDetailEdit, attachmentFormData : any): Promise<SaveResult>;
    
}

export class AddRequestService implements IAddRequestService {
    static $inject = ['$http', '$filter','requestDetailEditService'];

    constructor(private _$http: angular.IHttpService, private $filter: ng.IFilterService,
        private _requestDetailEditService: IRequestDetailEditService
       ) {

        
    }

    getDetail(copyTrackingId: number): Promise<RequestDetailEdit> {
       return  this._requestDetailEditService.getDetail(copyTrackingId,false);
    }

    submitRequestWithAttachments(requestDetailEdit: RequestDetailEdit, attachmentFormData: any): Promise<SaveResult> {

        var addRequestDetailEdit = this.getJsonFormatOfRequestDetailEditModel(requestDetailEdit);

        if (attachmentFormData === null) {
            attachmentFormData = new FormData();
        }
       
        attachmentFormData.append("requestDetailData", angular.toJson(addRequestDetailEdit));

        var request = {
            method: 'POST',
            url: '/Request/CreateShipment',
            data: attachmentFormData,
            headers: {
                'Content-Type': undefined,
                'Accept': '*/*' 
            }
        };

        return new Promise<any>((resolve, reject) => {
            this._$http(request)
                .then(
                    (response: any) => {
                        resolve(response.data);
                    })
                .catch(
                    (response: any) => {
                        reject(response.data);
                    });
        });
    }


    private formatDateWithTimeZone(date: Date): Date {
        return (this.$filter("date")(date, "yyyy-MM-dd")) as any;
    }

   private getJsonFormatOfRequestDetailEditModel(requestDetailEdit : RequestDetailEdit): any {
        var requestShipment;
        if (requestDetailEdit.requestDetail.requestShipment !== undefined) {
            requestDetailEdit.requestDetail.requestShipment.requestedDeliveryDate = angular.copy(this 
                .formatDateWithTimeZone(angular.copy(requestDetailEdit.requestDetail.requestShipment.requestedDeliveryDate)));
            requestDetailEdit.requestDetail.requestShipment.shipmentReadyDate = angular.copy(this
                .formatDateWithTimeZone(angular.copy(requestDetailEdit.requestDetail.requestShipment.shipmentReadyDate)));
            requestShipment = requestDetailEdit.requestDetail.requestShipment.toJson();
        }

        var requestConsignee;
        if (requestDetailEdit.requestDetail.requestConsignee !== undefined) {
            requestConsignee  = requestDetailEdit.requestDetail.requestConsignee.toJson();
        }
        var requestPickupDetail;
        if (requestDetailEdit.requestDetail.requestPickupDetail !== undefined) {
            requestPickupDetail = requestDetailEdit.requestDetail.requestPickupDetail.toJson();
        }
        var requestDetail = { requestShipment, requestConsignee, requestPickupDetail };
        
        var requestMaterials = [];

        if (requestDetailEdit.requestMaterial.requestMaterials !== undefined) {
            for (var im = 0; im <  requestDetailEdit.requestMaterial.requestMaterials.length ; im++) {
                requestMaterials[im] = requestDetailEdit.requestMaterial.requestMaterials[im].toJson();
            }
        }

        var requestPackages = [];

        if (requestDetailEdit.requestMaterial.requestMaterials !== undefined) {
            for (var ip = 0; ip < requestDetailEdit.requestMaterial.requestPackages.length; ip++) {
                requestPackages[ip] = requestDetailEdit.requestMaterial.requestPackages[ip].toJson();
            }
        }

        var requestAssignedMaterialToPackage = [];

        if (requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage  !== undefined) {
            for (var iam = 0; iam < requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length; iam++) {
                
               var assignedPc = requestDetailEdit.requestMaterial
                    .requestAssignedMaterialToPackage[iam].assignedPc;

               var requestMaterialEdit = requestDetailEdit.requestMaterial
                    .requestAssignedMaterialToPackage[iam].requestMaterials.toJson();

               var packages = [];
               var indexOfPackages = 0;
               for (var iamp = 0; iamp < requestDetailEdit.requestMaterial
                   .requestAssignedMaterialToPackage[iam].requestPackages.length; iamp++) {
                   
                   if (requestDetailEdit.requestMaterial
                       .requestAssignedMaterialToPackage[iam].requestPackages[iamp] !==
                       undefined &&
                       requestDetailEdit.requestMaterial
                       .requestAssignedMaterialToPackage[iam].requestPackages[iamp].quantity !==
                       undefined &&
                       requestDetailEdit.requestMaterial
                       .requestAssignedMaterialToPackage[iam].requestPackages[iamp].quantity !==
                       null &&
                       requestDetailEdit.requestMaterial
                       .requestAssignedMaterialToPackage[iam].requestPackages[iamp].quantity >
                       0 
                   ) {

                       packages[indexOfPackages] = requestDetailEdit.requestMaterial
                           .requestAssignedMaterialToPackage[iam].requestPackages[iamp].toJson();
                       indexOfPackages = indexOfPackages + 1;
                   }
               }
                
               requestAssignedMaterialToPackage[iam] = { assignedPc, requestMaterialEdit, packages }
            }
        }

        var shipmentRequestLetter;
        if (requestDetailEdit  !== undefined && requestDetailEdit.requestLetter !== undefined) {
            shipmentRequestLetter = requestDetailEdit.requestLetter.toJSON();
        }
       
        var requestMaterial = { requestMaterials, requestPackages, requestAssignedMaterialToPackage };

        if (requestDetailEdit.localizedCurrentTime == undefined)
            requestDetailEdit.localizedCurrentTime = (new Date()).toLocaleString();

        var rqDetailEdit = { "localizedCurrentTime": requestDetailEdit.localizedCurrentTime, requestDetail, requestMaterial, shipmentRequestLetter };

        return rqDetailEdit;

    }


    loadAllPackagesToAssignMaterials(loadAllRequestDetailEdit: RequestDetailEdit): RequestDetailEdit {
       
        if (loadAllRequestDetailEdit !== undefined &&
            loadAllRequestDetailEdit.requestMaterial !== undefined &&
            loadAllRequestDetailEdit.requestMaterial.requestPackages !== undefined &&
            loadAllRequestDetailEdit.requestMaterial.requestMaterials !== undefined &&
            loadAllRequestDetailEdit.requestMaterial.requestAssignedMaterialToPackage !== undefined) {
            for (var iamp = 0;
                iamp < loadAllRequestDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length;
                iamp++
            ) {

                loadAllRequestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iamp].requestPackages = [];
                loadAllRequestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iamp].requestPackages = angular
                    .copy(loadAllRequestDetailEdit.requestMaterial.requestPackages);
            }
        }
        
        return loadAllRequestDetailEdit;
    }

    loadAssignedPackagesToAssignMaterial(rqDetailEdit: RequestDetailEdit,
        copyRequestAssignedMaterialToPackages: RequestAssignedMaterialToPackage[]): RequestDetailEdit {
        
        if (rqDetailEdit !== undefined &&
            rqDetailEdit.requestMaterial !== undefined &&
            rqDetailEdit.requestMaterial.requestPackages !== undefined &&
            rqDetailEdit.requestMaterial.requestMaterials !== undefined &&
            rqDetailEdit.requestMaterial.requestAssignedMaterialToPackage !== undefined) {

            for (var iamp = 0; iamp < rqDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length; iamp++) {

                for (let eachcopyAssignedPackage of copyRequestAssignedMaterialToPackages[iamp].requestPackages) {

                    for (let eachUnAssignedPackage of rqDetailEdit.requestMaterial
                        .requestAssignedMaterialToPackage[iamp].requestPackages) {

                        if (eachUnAssignedPackage.recordNumber === eachcopyAssignedPackage.recordNumber) {

                            eachUnAssignedPackage.quantity =
                                angular.copy(eachcopyAssignedPackage.quantity);
                            eachUnAssignedPackage.packageId =
                                angular.copy(eachcopyAssignedPackage.packageId);
                        }
                    }
                }
            }
        }
        
        return rqDetailEdit;
    }
}


angular
    .module('deliveryCreate.app')
    .service('addRequestService', AddRequestService);




/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/addRequest/services/addRequestService.ts
 **/